import { color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
import { iconBaseLarge, iconBase, base, baseLarge } from "./_base.js";
const classNamePrefix = "umd-action-primary";
const primaryBase = {
  backgroundColor: color.red,
  border: `1px solid ${color.red}`,
  color: color.white,
  transition: "background 0.5s ease-in-out, border 0.5s ease-in-out, color 0.5s ease-in-out",
  [`&:hover, &:focus`]: {
    border: `1px solid ${color.redDark}`,
    backgroundColor: color.redDark
  }
};
function composePrimary(options) {
  const { size = "normal", color: buttonColor = "default" } = options || {};
  let composed = {};
  if (size === "normal") {
    composed = {
      ...base
    };
  } else if (size === "large") {
    composed = {
      ...baseLarge
    };
  }
  if (buttonColor === "default") {
    composed = {
      ...composed,
      ...primaryBase,
      "& svg": size === "large" ? { ...iconBaseLarge, fill: color.white } : { ...iconBase, fill: color.white }
    };
  } else if (buttonColor === "white") {
    composed = {
      ...composed,
      backgroundColor: color.gray.lighter,
      color: color.black,
      border: `1px solid ${color.white}`,
      transition: "background 0.5s ease-in-out, border 0.5s ease-in-out, color 0.5s ease-in-out",
      [`&:hover, &:focus`]: {
        border: `1px solid ${color.redDark}`,
        backgroundColor: color.redDark,
        color: color.white,
        "& svg": {
          fill: color.white
        }
      },
      "& svg": size === "large" ? { ...iconBaseLarge, fill: color.red } : { ...iconBase, fill: color.red }
    };
  }
  let className = `${classNamePrefix}`;
  const deprecatedAliases = [];
  if (size === "large" && buttonColor === "default") {
    className = `${classNamePrefix}-large`;
  } else if (size === "normal" && buttonColor === "white") {
    className = `${classNamePrefix}-white`;
  } else if (size === "large" && buttonColor === "white") {
    className = `${classNamePrefix}-large-white`;
  } else if (size === "normal" && buttonColor === "default") {
    deprecatedAliases.push("umd-forms-actions-primary");
  }
  return objectWithClassName({
    ...composed,
    className: deprecatedAliases.length > 0 ? [className, ...deprecatedAliases] : className
  });
}
const normal = composePrimary();
const large = composePrimary({ size: "large" });
export {
  composePrimary,
  large,
  normal
};
//# sourceMappingURL=primary.js.map
